import type { ReactNode } from 'react';

export const symbol_timer_10: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M535-280h185v-400H535v400Zm0 80q-33.33 0-56.67-23.33Q455-246.67 455-280v-400q0-33.33 23.33-56.67Q501.67-760 535-760h185q33.33 0 56.67 23.33Q800-713.33 800-680v400q0 33.33-23.33 56.67Q753.33-200 720-200H535ZM255-680h-54q-16.67 0-28.33-11.74Q161-703.47 161-720.24q0-16.76 11.67-28.26Q184.33-760 201-760h104q12.75 0 21.38 8.62Q335-742.75 335-730v490q0 16.67-11.74 28.33Q311.53-200 294.76-200q-16.76 0-28.26-11.67Q255-223.33 255-240v-440Z"
		/>
	</svg>
);
